import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const SalaryApi = createApi({
  reducerPath: "SalaryApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    get_total_salary: builder.query({
      query: () => "get_total_salary",
      transformResponse: (response) => response?.data || [],
    }),

    cuurMonthAllSalary: builder.query({
      query: () => "current_month_all_dept_total_salary",
      transformResponse: (response) => response?.data || [],
    }),
    singleDeptTotalSalary: builder.query({
      query: (deptId) => `single_dept_whole_year_total_salary/${deptId}`,
      transformResponse: (response) => response?.data || [],
    }),
    getMonthlySalaryById: builder.mutation({
      query: (data) => ({
        url: `get_salary_by_id_month_year`,
        method: "POST",
        body: data,
      }),
    }),
    checkSalaryStatus: builder.mutation({
      query: (data) => ({
        url: `check_salary_status`,
        method: "POST",
        body: data,
      }),
    }),

    updateSalaryWithFinance: builder.mutation({
      query: (data) => ({
        url: `update_all_salary_with_finance`,
        method: "PUT",
        body: data,
      }),
    }),

    updateSalary: builder.mutation({
      query: (data) => ({
        url: `update_salary`,
        method: "PUT",
        body: data,
      }),
    }),
    getSalaryByMonthYear: builder.mutation({
      query: (data) => ({
        url: `get_salary_by_month_year`,
        method: "POST",
        body: data,
      }),
    }),
    getUsersByDeptId: builder.query({
      query: (deptId) => `get_user_by_deptid/${deptId}`,
      transformResponse: (response) => response,
    }),

    leftEmployees: builder.query({
      query: ({ dept_id, month, year }) => ({
        url: `left_employees`,
        method: "POST",
        body: { dept_id, month, year },
      }),
      transformResponse: (response) => response,
    }),
    
    newJoiners: builder.query({
      query: ({ dept_id, month, year }) => ({
        url: `new_joiners`,
        method: "POST",
        body: { dept_id, month, year },
      }),
      transformResponse: (response) => response,
    }),
    
    deleteAllAttendance: builder.mutation({
      query: ({ dept, month, year }) => ({
        url: "delete_all_attendance",
        method: "DELETE",
        body: { dept, month, year },  
      }),
    }),
    
  }),
});

export const {
  //Role api
  useGet_total_salaryQuery,
  useCuurMonthAllSalaryQuery,
  useSingleDeptTotalSalaryQuery,
  useGetMonthlySalaryByIdMutation,
  useUpdateSalaryMutation,
  useCheckSalaryStatusMutation,
  useGetSalaryByMonthYearMutation,
  useUpdateSalaryWithFinanceMutation,
  useGetUsersByDeptIdQuery,
  useLeftEmployeesQuery,
  useNewJoinersQuery,
  useDeleteAllAttendanceMutation
} = SalaryApi;

export default SalaryApi;
